<!-- eslint-disable max-len, vue/no-confusing-v-for-v-if -->
<template>
  <div
    v-if="dataDetail"
    id="vp-container">

    <!-- Popup new version -->
    <div
      :class="{'show': showPopupNewVersion}"
      class="popup-new-version"
    >
      <p class="popup-text">A new version of Visual Programming is available </p>
      <div class="line" />
      <p
        class="btn-refresh"
        @click="updateNewVersion"
      >
        Update Now
      </p>
    </div>

    <!-- Title Tab -->
    <j-headful
      v-if="name_automation"
      :title="name_automation"
    />

    <!-- Header -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
    >
      <div class="header-automation">
        <!-- Title & Type -->
        <div class="d-flex align-items-center">
          <!-- Back to list -->
          <img
            src="@/assets/icon/arrow-left.svg"
            width="18"
            height="18"
            class="mr-2 cursor-pointer"
            @click="$router.push('/visual-programming')"
          >

          <!-- VP icon -->
          <img
            v-if="dataDetail && dataDetail.trigger.type === 'form'"
            :src="require('@/assets/automation/data_manager.svg')"
            width="30"
            height="30"
          >
          <img
            v-else-if="dataDetail && dataDetail.trigger.type === 'event'"
            :src="require('@/assets/automation/event.svg')"
            width="30"
            height="30"
          >
          <img
            v-else-if="dataDetail && dataDetail.trigger.type === 'function'"
            :src="require('@/assets/automation/function.svg')"
            width="30"
            height="30"
          >
          <img
            v-else-if="dataDetail && dataDetail.trigger.type === 'job' ||
            dataDetail.trigger.type === 'dedicated_job'"
            :src="require('@/assets/automation/job.svg')"
            width="30"
            height="30"
          >
          <img
            v-else
            :src="require('@/assets/automation/api.svg')"
            width="30"
            height="30"
          >

          <!-- VP title -->
          <div
            v-click-outside="updateTitleAutomation"
            :class="{'header-item--active': isEditTitleActive}"
            class="header-item ml-2"
          >
            <span>{{ dataDetail ? dataDetail.id : '' }}</span>
            <div class="line"/>
            <div
              class="title-wrap"
            >
              <h3
                :style="isEditTitleActive ? {'display': 'none'} : {}"
                class="title-input-label"
                @dblclick="editTitleAutomation"
              >
                {{ name_automation }}
                <div class="tooltip-component">
                  Double Click to edit this Title
                </div>
              </h3>
              <input
                ref="titleInput"
                :style="isEditTitleActive ?
                  { 'width': `${name_automation.length < 72 ? name_automation.length * 7.5 : 517}px`,
                    'display': 'inline-block'} : {}"
                v-model="name_automation"
                type="text"
                class="title-input"
                @keyup.enter="updateTitleAutomation"
              >
            </div>
          </div>

          <!-- VP Source -->
          <div class="header-item ml-2">
            <div class="data-source">
              <div
                v-if="dataDetail && dataDetail.trigger.type.includes('api') || dataDetail.trigger.type.includes('webhook')"
                class="method"
              >
                {{ dataDetail.trigger[dataDetail.trigger.type].method }}
              </div>

              <div
                v-if="dataDetail && dataDetail.trigger.type.includes('api') || dataDetail.trigger.type.includes('webhook')"
                class="base-url"
              >
                {{ baseURL }}
              </div>

              <p
                v-if="dataDetail && !dataDetail.trigger.type.includes('api') && !dataDetail.trigger.type.includes('webhook')"
                :class="{ 'mr-0': dataDetail.trigger.type === 'form' }"
                class="name"
              >
                {{ triggerName }}
              </p>

              <p
                v-else
                class="name"
              >
                /{{ dataDetail.trigger[dataDetail.trigger.type].url }}
              </p>

              <i
                v-if="dataDetail && dataDetail.trigger.type !== 'form'"
                class="fa fa-clone copy-icon"
                @click="copyToClipboard"
              />
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center">
          <div
            class="tags-header"
            @click="openBlockProperties('code-editor', 1)"
          >
            <img
              src="@/assets/icon/code-editor.svg"
              height="14"
              class="mr-1"
            >
            <span>Code Editor</span>
          </div>
          <div
            class="tags-header"
            @click="openBlockProperties('run-history', 1)"
          >
            <img
              src="@/assets/icon/run-history.svg"
              height="14"
              class="mr-1"
            >
            <span>Run History</span>
          </div>
          <div
            v-if="dataDetail && (dataDetail.trigger.type === 'job' || dataDetail.trigger.type === 'dedicated_job')"
            class="tags-header"
            @click="openBlockProperties('monitoring', 1)"
          >
            <img
              src="@/assets/icon/monitor.svg"
              height="14"
              class="mr-1"
            >
            <span>Job Monitoring</span>
          </div>
          <div
            v-if="dataDetail.updated_at"
            class="time-ago m__r--5"
          >
            {{ timeAgo }}
          </div>
          <!-- <jTooltipCreateView
            :custom="true"
            :description="infoTooltip"
            width="14"
            position="left"
            class="pull-right m__r--10"
          /> -->
          <div
            v-if="active"
            class="vp-on"
          >
            ON
          </div>
          <div
            v-else
            class="vp-off"
          >
            OFF
          </div>
          <i
            id="configPopover"
            class="fa fa-ellipsis-v fa-lg cursor-pointer m__l--10 m__t--4"
            style="color: #4A4A4A;"
          />
        </div>
      </div>

      <!-- <b-row id="vp-container-tab">
        <b-col
          :class="{'studio-page-tab-active' : modeAutomation === 'diagram'}"
          class="studio-page-tab centered"
          style="padding-top: 37px;"
          @click="selectTab('diagram')">
          <h4>DIAGRAM VIEW</h4>
          <div
            v-if="modeAutomation === 'diagram'"
            class="underline-data"/>
        </b-col>
        <b-col
          :class="{'studio-page-tab-active' : modeAutomation === 'log'}"
          class="studio-page-tab centered"
          style="padding-top: 37px;"
          @click="selectTab('log')">
          <h4>RUN HISTORY</h4>
          <div
            v-if="modeAutomation === 'log'"
            class="underline-data"/>
        </b-col>
        <b-col
          v-if="dataDetail && dataDetail.trigger.type === 'job'"
          :class="{'studio-page-tab-active' : modeAutomation === 'job-monitoring'}"
          class="studio-page-tab centered"
          style="padding-top: 37px;"
          @click="selectTab('job-monitoring')">
          <h4>JOB MONITORING</h4>
          <div
            v-if="modeAutomation === 'job-monitoring'"
            class="underline-data"/>
        </b-col>
        <b-col
          v-if="dataDetail && dataDetail.trigger.type === 'dedicated_job'"
          :class="{'studio-page-tab-active' : modeAutomation === 'dedicated-job-monitoring'}"
          class="studio-page-tab centered"
          style="padding-top: 37px;"
          @click="selectTab('dedicated-job-monitoring')">
          <h4>JOB MONITORING</h4>
          <div
            v-if="modeAutomation === 'dedicated-job-monitoring'"
            class="underline-data"/>
        </b-col>
        <b-col
          :class="{'studio-page-tab-active' : modeAutomation === 'code'}"
          class="studio-page-tab centered"
          style="padding-top: 37px;"
          @click="selectTab('code')">
          <h4>CODE EDITOR</h4>
          <div
            v-if="modeAutomation === 'code'"
            class="underline-data"/>
        </b-col>
      </b-row> -->
    </div>

    <div
      v-if="showBlockAutomation"
      class="studio-page-content vp-page-content">
      <!-- Diagram ---------------------------------------------------------------------- -->
      <div
        v-show="modeAutomation === 'diagram'"
        class="body-automation cursor-grab"
      >
        <j-pan-zoom
          ref="zoomWrapper"
          :options="zoomOptions"
          selector=".zoomable"
        >
          <div class="zoomable wrap-layer">
            <!-- Block Trigger -->
            <j-automation-trigger
              ref="automationTrigger"
              :data-edit="dataDetail"
            />

            <div class="hierarchy-line-vertical" />
            <div class="hierarchy-line-arrow-down" />

            <diagram-view
              :data-actions="data_automation"
              :row="1" />

            <!-- Add Block Action Last Block -->
            <div
              id="automationAdd"
              class="btn-action-add-automation-plus"
              @click="openPopoverAdd('popoverAddAutomation')"
            >
              <i class="fa fa-plus"/>
            </div>

            <b-popover
              v-if="popoverAddBlock && popoverAddBlock === 'popoverAddAutomation'"
              ref="popoverAddAutomation"
              target="automationAdd"
              triggers="click"
              placement="bottom">
              <ModalListAction
                v-click-outside="hideAllPopoverAdd"
                @select="selectActionBlock"
              />
              <!-- <div
                class="add-automation"
                @click="addBlock('action')">
                <img
                  :src="require('@/assets/automation/action-lg.png')"
                  width="18"
                  class="m__r--5">Action</div>
              <div
                class="add-automation"
                @click="addBlock('conditional')">
                <img
                  :src="require('@/assets/automation/conditional.svg')"
                  width="18"
                  class="m__r--5">Conditional</div>
              <div
                class="add-automation"
                @click="addBlock('while')">
                <img
                  :src="require('@/assets/automation/while.svg')"
                  width="18"
                  class="m__r--5">While</div>
              <div
                class="add-automation"
                @click="addBlock('javascript')">
                <img
                  :src="require('@/assets/automation/script.svg')"
                  width="18"
                  class="m__r--5">Script</div> -->
            </b-popover>
          </div>
        </j-pan-zoom>

        <!-- Zoom button -->
        <div
          :class="{'wrap-zoom-no-sidebar': !is_sidebar_minimized}"
          class="wrap-zoom">
          <div
            class="zoom-btn"
            @click="handleZoom('zoomin')"
          >
            <i class="fa fa-plus" />
          </div>
          <div
            class="zoom-btn"
            @click="handleZoom('zoomout')"
          >
            <i class="fa fa-minus" />
          </div>
        </div>
      </div>
      <!-- End Diagram ---------------------------------------------------------------------- -->

      <!-- Block Properties ---------------------------------------------------------------------- -->
      <div
        v-show="modeAutomation === 'diagram'"
        :class="{ 'show-container-properties-automation' : propertiesOpened,
                  'hide-container-properties-automation' : !propertiesOpened }"
        class="container-properties-automation block-action">
        <div class="d-flex align-items-center justify-content-between">
          <div class="header-properties-wrap">
            <div class="label-log-detail">Properties</div>
            <div v-if="propertiesTypeBlock === 'trigger'">
              <img
                :src="require('@/assets/automation/trigger.png')"
                width="15"
                class="m__r--5 m__l--12">
              <span class="title-automation m__r--5">TRIGGER</span>
            </div>
            <div v-if="propertiesTypeBlock === 'action'">
              <img
                :src="require('@/assets/automation/action-lg.png')"
                width="15"
                class="m__r--5 m__l--12">
              <span class="title-automation m__r--5">ACTION</span>
            </div>
            <div v-if="propertiesTypeBlock === 'conditional'">
              <img
                :src="require('@/assets/automation/conditional.svg')"
                width="15"
                class="m__r--5 m__l--12">
              <span class="title-automation m__r--5">CONDITIONAL</span>
            </div>
            <div v-if="propertiesTypeBlock === 'while'">
              <img
                :src="require('@/assets/automation/while.svg')"
                width="15"
                class="m__r--5 m__l--12">
              <span class="title-automation m__r--5">WHILE</span>
            </div>
            <div v-if="propertiesTypeBlock === 'javascript'">
              <img
                :src="require('@/assets/automation/script.svg')"
                width="15"
                class="m__r--5 m__l--12">
              <span class="title-automation m__r--5">SCRIPT</span>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <img
              v-if="propertiesTypeBlock === 'javascript'"
              src="@/assets/icon/fullscreen.svg"
              alt="fullscreen"
              class="toggle-fullscreen"
              @click="fullscreenBlock"
            >
            <div
              class="close-properties-automation"
              @click="hideProperties">
              <img
                :src="require('@/assets/icon/icon-close-properties.svg')"
                width="25">
            </div>
          </div>
        </div>

        <j-automation-trigger
          v-if="propertiesOpened && propertiesTypeBlock === 'trigger'"
          ref="automationTriggerPro"
          :data-edit="dataDetail"
          :on-properties="true"/>

        <j-automation-javascript
          v-if="propertiesOpened && propertiesTypeBlock === 'javascript'"
          ref="automationJavascriptPro"
          :id="propertiesIDBlock"
          :data-edit="propertiesDataBlock"
          :data-history="historyActionBlockScript"
          :on-properties="true"/>

        <j-automation-action
          v-if="propertiesOpened && propertiesTypeBlock === 'action'"
          ref="automationActionPro"
          :id="propertiesIDBlock"
          :data-edit="propertiesDataBlock"
          :on-properties="true"/>

        <j-automation-conditional
          v-if="propertiesOpened && propertiesTypeBlock === 'conditional'"
          ref="automationConditionalPro"
          :id="propertiesIDBlock"
          :data-edit="propertiesDataBlock"
          :on-properties="true"/>

        <j-automation-while
          v-if="propertiesOpened && propertiesTypeBlock === 'while'"
          ref="automationWhilePro"
          :id="propertiesIDBlock"
          :data-edit="propertiesDataBlock"
          :on-properties="true"/>

        <div
          :class="{'show-privilege-data-manager-access-button' : propertiesOpened,
                   'hide-privilege-data-manager-access-button' : !propertiesOpened,
                   'justify-content-end': propertiesTypeBlock === 'trigger' || !propertiesDataBlock}"
          class="privilege-data-manager-access-button">
          <button
            v-if="propertiesTypeBlock !== 'trigger' && propertiesDataBlock"
            class="button-border"
            @click="deleteBlockAutomation">
            <i class="fa fa-trash" /> Delete
          </button>

          <div class="d-flex align-items-center">
            <button
              class="button-border mr-2"
              @click="hideProperties">
              Close
            </button>

            <button
              class="button-blue"
              @click="updateBlockAutomation">
              Update
            </button>
          </div>
        </div>
      </div>

      <!-- Code ---------------------------------------------------------------------- -->
      <div
        v-if="modeAutomation === 'code'"
        class="body-automation block-log p--15">
        <!-- <span
          class="btn-apply-action-automation pull-right"
          @click="applyOnlyAutomation">
          Apply
        </span>
        <j-monaco-editor
          v-if="showCodeEditor"
          ref="scriptEditor"
          :value="jsonData"
          language="json"
          class="m__t--50"
        /> -->
      </div>
      <!-- End Code ---------------------------------------------------------------------- -->

      <!-- Job Monitoring
      ---------------------------------------------------------------------- -->
      <div
        v-if="modeAutomation === 'job-monitoring'"
        class="p--15">
        <jVPJobMonitoring :id="visprogId"/>
      </div>
      <!-- End Job Monitoring ---------------------------------------------------------------------- -->

      <!-- Dedicated Job Monitoring
      ---------------------------------------------------------------------- -->
      <div
        v-if="modeAutomation === 'dedicated-job-monitoring'"
        class="p--15">
        <jVPDedicatedJobMonitoring :id="visprogId"/>
      </div>
      <!-- End Dedicated Job Monitoring ---------------------------------------------------------------------- -->

      <!-- Log History ---------------------------------------------------------------------- -->
      <div
        v-if="modeAutomation === 'log'"
        class="body-automation block-log p--15">
        <div v-if="!isBlockLog">
          <div class="label-log-history">Visual Programming Running History</div>
          <div
            v-if="!showDataTable && !load_first"
            class="d-flex justify-content-center"
            style="height: 400px; width: 100%">
            <div class="lds-ellipsis"><div/><div/><div/><div/></div>
          </div>
          <v-server-table
            v-if="showDataTable"
            v-show="load_first"
            ref="automationLogComponent"
            :columns="columns"
            :options="table_options"
            class="jTable table-run-history"
            @loading="loading"
            @loaded="loaded">
            <div
              slot="beforeFilter"
              class="custom-search">
              <b-form inline>
                <b-button
                  class="btn grey btn-import-form"
                  @click="$refs.automationLogComponent.refresh()">
                  <i class="fa fa-refresh"/> Refresh
                </b-button>
              </b-form>
            </div>

            <div
              slot="status"
              slot-scope="props">
              <img
                :src="require(`@/assets/log/${props.row.status}.png`)"
                class="m__r--5">
              {{ props.row.status === 'success' ? 'Ran successfully' : (props.row.status === 'running' ? 'Running' : 'Ran error') }}
            </div>
            <div
              slot="runtime"
              slot-scope="props">
              {{ props.row.runtime }} ms
            </div>
            <div
              slot="time"
              slot-scope="props">
              {{ convertDateTime(props.row.time) }}
            </div>
          </v-server-table>
          <div class="custom-pagination">
            <div
              class="btn-previous"
              @click="previousPage"><i class="fa fa-chevron-left"/></div>
            <div
              class="btn-forward"
              @click="forwardPage"><i class="fa fa-chevron-right"/></div>
          </div>
        </div>
        <div v-if="isBlockLog">
          <div class="d-flex">
            <i
              class="fa fa-arrow-left cursor-pointer"
              @click="isBlockLog = false; showLogDetail = false;"/>
            <div class="info-selected-block">
              {{ historyDetail.running_id }} <br>
              {{ convertDateTime(historyDetail.time) }}
            </div>
          </div>
          <div class="label-log-history">Block Visual Programming Running History</div>
          <v-client-table
            :data="dataListBlockLog"
            :columns="columns_block"
            :options="table_options_block"
            class="jTable"
            @row-click="openDetailBlockLog">
            <div
              slot="status"
              slot-scope="props">
              <img
                :src="require(`@/assets/log/${props.row.status}.png`)"
                class="m__r--5">
              {{ props.row.status === 'success' ? 'Ran successfully' : (props.row.status === 'running' ? 'Running' : 'Ran error') }}
            </div>
            <div
              slot="runtime"
              slot-scope="props">
              {{ props.row.runtime }} ms
            </div>
            <div
              slot="time"
              slot-scope="props">
              {{ convertDateTime(props.row.time) }}
            </div>
          </v-client-table>
        </div>
        <div
          :class="{'show-container-log-detail' : showLogDetail, 'hide-container-log-detail' : !showLogDetail}"
          class="container-log-detail">
          <b-row>
            <b-col md="6">
              <div class="label-log-detail">Log Detail</div>
            </b-col>
            <b-col md="6">
              <div
                class="close-properties-automation pull-right"
                @click="showLogDetail = false">X</div>
            </b-col>
          </b-row>
          <div
            v-if="showLogDetail && logDetail"
            class="label-id-log-detail">
            #{{ logDetail.action_id }} - {{ logDetail.type }}
          </div>
          <div
            v-if="showLogDetail && logDetail"
            class="label-id-log-detail">
            Runtime : <span class="runtime-log-detail">{{ logDetail.runtime }} ms</span>
          </div>
          <div
            v-if="showLogDetail && loadLogDetailData"
            class="d-flex justify-content-center align-items-center"
            style="height: 400px; width: 100%">
            <div class="lds-ellipsis"><div/><div/><div/><div/></div>
          </div>
          <div
            v-if="showLogDetail && !loadLogDetailData && logDetail.warning"
            class="container-warning-log-detail">
            <div class="label-warning-log-detail">WARNING</div>
            <div class="warning-log-detail">{{ logDetail.warning }}</div>
          </div>
          <div
            v-if="showLogDetail && !loadLogDetailData && logDetail.status === 'error'"
            class="container-error-log-detail">
            <div class="label-error-log-detail">ERROR</div>
            {{ logDetail.error }}
          </div>
          <div
            v-if="showLogDetail && !loadLogDetailData"
            class="container-data-log-detail">
            <div class="label-data-log-detail">DATA</div>
            <pre class="debug-log-detail">{{ logDetail.data }}</pre>
          </div>
          <div
            class="btn-close-log-detail"
            @click="showLogDetail = false">Close</div>
        </div>
      </div>
      <!-- End Log History ---------------------------------------------------------------------- -->
    </div>

    <!-- Popover Config ---------------------------------------------------------------------- -->
    <b-popover
      v-click-outside="hideAllPopover"
      ref="configPopoverRef"
      :show.sync="configPopoverShow"
      target="configPopover"
      placement="left">
      <div
        class="add-automation"
        @click="configAutomation">Config</div>
      <div
        class="add-automation"
        @click="removeAutomation">Delete</div>
    </b-popover>

    <!-- Modal Config ---------------------------------------------------------------------- -->
    <b-modal
      ref="configModal"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div class="label-create-form-data font-weight-bold mb-4">CONFIG VISUAL PROGRAMMING</div>
      <b-form-group :class="{'error-input' : $v.name_automation.$error}">
        <label for="name"> Name </label>
        <j-input
          id="name"
          v-model="$v.name_automation.$model"
          :error-required="$v.name_automation.$error"
          placeholder="Enter name here"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.description.$error}">
        <label for="description"> Description </label>
        <j-textarea
          v-model="$v.description.$model"
          :error-required="$v.description.$error"
          :max-length="255"
          placeholder="Enter description here"
        />
      </b-form-group>

      <b-row class="mt-3">
        <b-col md="3">
          <b-form-group>
            <label> Active </label>
            <j-toggle v-model="active"/>
          </b-form-group>
        </b-col>
        <b-col
          v-if="dataDetail && dataDetail.trigger.type === 'form'"
          md="3">
          <b-form-group>
            <label> Synchronous </label>
            <j-toggle v-model="is_sync"/>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group>
            <label> Disable Run History </label>
            <j-toggle
              v-model="disable_run_history"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-right m__t--20">
        <b-button
          class="btn m__r--5"
          @click="closeConfigAutomation">
          Cancel
        </b-button>
        <b-button
          class="btn blue"
          @click="updateConfigAutomation">
          Update
        </b-button>
      </div>
    </b-modal>

    <!-- Modal fullscreen action block script javascript -->
    <b-modal
      ref="modalFullScript"
      class="mod-full-block"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-fullscreen">
        <div class="d-flex align-items-center justify-content-between">
          <div class="label-log-detail">Properties</div>

          <div class="d-flex align-items-center">
            <img
              src="@/assets/icon/minimize.svg"
              alt="fullscreen"
              class="toggle-fullscreen"
              @click="minimizeBlock"
            >
            <div
              class="close-properties-automation"
              @click="hidePropertiesFull"
            >
              <img
                :src="require('@/assets/icon/icon-close-properties.svg')"
                width="25">
            </div>
          </div>
        </div>

        <j-automation-javascript
          v-if="showModalFullscreen"
          ref="automationJavascriptFullPro"
          :data-edit="propertiesDataBlock"
          :data-history="historyActionBlockScript"
          :on-properties="true"
          :on-fullscreen="true"
        />

        <div
          class="btn-update-properties-automation"
          @click="updateBlockAutomation">Update</div>
        <div
          class="btn-close-properties-automation"
          @click="hidePropertiesFull">Close</div>
        <div
          class="btn-delete-properties-automation"
          @click="deleteBlockAutomation">Delete</div>
      </div>
    </b-modal>

    <!-- Modal Code Editor ---------------------------------------------------------------------- -->
    <div
      v-if="showModalCodeEditor"
      id="modal-code-editor"
      class="container-modal-code-editor"
    >
      <div
        class="close-properties-automation float-right"
        @click="toggleModalCodeEditor(false)">
        <img
          :src="require('@/assets/icon/icon-close-properties.svg')"
          width="25">
      </div>
      <span
        class="btn-apply-action-automation d-block m-0"
        @click="applyOnlyAutomation">
        Apply
      </span>
      <j-monaco-editor
        v-if="showCodeEditor"
        ref="scriptEditor"
        :value="jsonData"
        language="json"
        class="m__t--20"
      />
    </div>

    <!-- Modal Monitoring ---------------------------------------------------------------------- -->
    <div
      v-if="showModalMonitoring"
      id="modal-monitoring"
      class="container-modal-code-editor"
    >
      <div
        class="close-properties-automation float-right"
        @click="toggleModalMonitoring(false)">
        <img
          :src="require('@/assets/icon/icon-close-properties.svg')"
          width="25">
      </div>
      <h4>{{ dataDetail && dataDetail.trigger.type === 'dedicated_job' ? 'Dedicated' : '' }} Job Monitoring</h4>
      <jVPJobMonitoring
        v-if="dataDetail && dataDetail.trigger.type === 'job'"
        :id="visprogId"
      />
      <jVPDedicatedJobMonitoring
        v-if="dataDetail && dataDetail.trigger.type === 'dedicated_job'"
        :id="visprogId"
      />
    </div>

    <!-- Block Run History ---------------------------------------------------------------------- -->
    <!-- Properties Stack 1 -->
    <div
      id="data-list-history"
      :class="{ 'show-container-properties-automation' : showBlockProperties && !showBlockStack2Properties,
                'hide-container-properties-automation' : !showBlockProperties,
                'show-container-properties-stack-2-automation': showBlockStack2Properties && !showBlockStack3Properties,
                'show-container-properties-stack-3-automation': showBlockStack3Properties }"
      class="container-properties-automation block-properties-run-history stack-1">
      <div class="header-properties-vp-wrap">
        <div class="header-properties-wrap">
          <div class="label-log-detail">Run History</div>
        </div>

        <div class="d-flex align-items-center">
          <div
            class="reload-data-run-history"
            @click="getDataRunHistory">
            <img
              :src="require('@/assets/icon/reload.png')"
              :style="imageStyleRotate"
              height="16">
          </div>
          <div
            class="close-properties-automation"
            @click="showBlockProperties = false">
            <img
              :src="require('@/assets/icon/icon-close-properties.svg')"
              width="25">
          </div>
        </div>
      </div>

      <div
        id="list-data-run-history"
        class="list-data-run-history"
      >
        <b-button
          id="filterLogList"
          :class="{
            'btn-filter-log--active': !!filterLog
          }"
          class="btn-filter-log mb-3"
          @click="openPopoverFilterLog"
        >
          <i class="fa fa-filter" /> Filter
        </b-button>

        <!-- Popover filter -->
        <b-popover
          ref="popoverFilterLog"
          :show.sync="popoverFilterLogShow"
          target="filterLogList"
          container="list-data-run-history"
          triggers="click"
          placement="bottom"
          title="Filter"
        >
          <j-popover-filter-run-history
            v-click-outside="closePopoverFilterLog"
            @apply-filter="handleFilterLog"
            @reset-filter="resetFilterLog"
          />
        </b-popover>

        <!-- Loading -->
        <template v-if="isLoadingListLog">
          <div
            v-for="i in 5"
            :key="i"
            class="skeleton-list-log"
          />
        </template>

        <!-- List  -->
        <template v-else-if="!isLoadingListLog && dataListRunHistory.length > 0">
          <div
            v-for="view in dataListRunHistory"
            :key="view.id"
            class="item-data-run-history"
          >
            <img
              :src="require('@/assets/automation/history.svg')"
              width="20">
            <div class="item-data-run-history__label">
              <div class="item-data-run-history__label-id">{{ view.id }}</div>
              <div class="item-data-run-history__label-time">{{ convertDateTime(view.time) }}</div>
            </div>
            <div class="item-data-run-history__div-runtime">
              <div class="item-data-run-history__label-runtime">Total Runtime</div>
              <div class="item-data-run-history__runtime">{{ view.runtime }} ms</div>
            </div>
            <img
              :src="require(`@/assets/log/${view.status}.png`)"
              height="23"
              width="23"
            >
            <div :class="`item-data-run-history__status ${view.status}`">
              {{ view.status === 'success' ? 'SUCCESS' : (view.status === 'running' ? 'RUNNING' : 'ERROR') }}
            </div>
            <div
              class="item-data-run-history__icon-fa"
              @click="openBlockProperties('run-history', 2, view)"
            ><i class="fa fa-chevron-right" /></div>
          </div>
        </template>

        <!-- Not found -->
        <div
          v-else-if="!isLoadingListLog && dataListRunHistory.length === 0"
          class="list-not-found">
          There are no items to show.
        </div>
      </div>
    </div>

    <!-- Properties Stack 2 -->
    <div
      :class="{ 'show-container-properties-automation' : showBlockStack2Properties && !showBlockStack3Properties,
                'hide-container-properties-automation' : !showBlockStack2Properties,
                'show-container-properties-stack-2-automation': showBlockStack3Properties }"
      class="container-properties-automation block-properties-run-history stack-2">
      <div class="header-properties-vp-wrap">
        <i
          class="fa fa-arrow-left cursor-pointer"
          @click="showBlockStack2Properties = false"/>

        <div
          v-if="historyDetail"
          class="item-data-run-history m__b--0">
          <img
            :src="require('@/assets/automation/history.svg')"
            width="20">
          <div class="item-data-run-history__label">
            <div class="item-data-run-history__label-id">{{ historyDetail.id }}</div>
            <div class="item-data-run-history__label-time">{{ convertDateTime(historyDetail.time) }}</div>
          </div>
          <div class="item-data-run-history__div-runtime">
            <div class="item-data-run-history__label-runtime">Total Runtime</div>
            <div class="item-data-run-history__runtime">{{ historyDetail.runtime }} ms</div>
          </div>
          <img
            :src="require(`@/assets/log/${historyDetail.status}.png`)"
            height="23"
            width="23"
          >
          <div :class="`item-data-run-history__status ${historyDetail.status}`">
            {{ historyDetail.status === 'success' ? 'SUCCESS' : (historyDetail.status === 'running' ? 'RUNNING' : 'ERROR') }}
          </div>
        </div>

        <div class="d-flex align-items-center">
          <div
            class="reload-data-run-history"
            @click="getDataBlockLog">
            <img
              :src="require('@/assets/icon/reload.png')"
              :style="imageStyleRotate"
              height="16">
          </div>
        </div>
      </div>

      <div
        id="list-detail-data-run-history"
        class="list-data-run-history"
      >
        <b-button
          id="filterDetailLogList"
          :class="{
            'btn-filter-log--active': !!filterDetailLog
          }"
          class="btn-filter-log mb-3"
          @click="openPopoverFilterDetailLog"
        >
          <i class="fa fa-filter" /> Filter
        </b-button>

        <!-- Popover filter -->
        <b-popover
          ref="popoverFilterDetailLog"
          :show.sync="popoverFilterDetailLogShow"
          target="filterDetailLogList"
          container="list-detail-data-run-history"
          triggers="click"
          placement="bottom"
          title="Filter"
        >
          <j-popover-filter-run-history
            v-click-outside="popoverFilterDetailLogShow"
            :is-filter-detail="true"
            @apply-filter="handleFilterDetailLog"
            @reset-filter="resetFilterDetailLog"
          />
        </b-popover>

        <!-- Loading -->
        <template v-if="isLoadingListDetailLog">
          <div
            v-for="i in 5"
            :key="i"
            class="skeleton-list-log"
          />
        </template>

        <!-- List -->
        <template v-else-if="!isLoadingListDetailLog && dataListBlockLog.length > 0">
          <div
            v-for="(view, index) in dataListBlockLog"
            :key="index"
            class="item-data-block-run-history"
          >
            <div class="item-data-run-history">
              <img
                :src="require('@/assets/automation/history.svg')"
                width="20">
              <div class="item-data-run-history__label">
                <div class="item-data-run-history__label-id">{{ view.id }}</div>
                <div class="item-data-run-history__label-time">{{ convertDateTime(view.time) }}</div>
              </div>
              <div class="item-data-run-history__div-runtime">
                <div class="item-data-run-history__label-runtime">Runtime</div>
                <div class="item-data-run-history__runtime">{{ view.runtime }} ms</div>
              </div>
              <img
                :src="require(`@/assets/log/${view.status}.png`)"
                height="23"
                width="23"
              >
              <div :class="`item-data-run-history__status ${view.status}`">
                {{ view.status === 'success' ? 'SUCCESS' : (view.status === 'running' ? 'RUNNING' : 'ERROR') }}
              </div>
              <img
                :src="require('@/assets/automation/open-tab.png')"
                width="20"
                height="20"
                class="item-data-run-history__open-tab"
                @click="openBlockProperties('run-history', 3, view, index)"
              >
            </div>
            <div class="item-data-run-history-info-type">
              <img
                :src="require(`@/assets/automation/${getIconBlockLog(view, index)}.svg`)"
                width="20"
                height="20"
                class="m__r--5">
              <div class="title-automation m__r--5">{{ getNameBlockLog(view, index) }}</div>
              <div class="id-block-automation">{{ view.action_id ? `#${view.action_id}` : '' }}</div>
            </div>

          </div>
        </template>

        <!-- Not found -->
        <div
          v-else-if="!isLoadingListDetailLog && dataListBlockLog.length === 0"
          class="list-not-found">
          There are no items to show.
        </div>
      </div>
    </div>

    <!-- Properties Stack 3 -->
    <div
      :class="{ 'show-container-properties-automation' : showBlockStack3Properties,
                'hide-container-properties-automation' : !showBlockStack3Properties }"
      class="container-properties-automation block-properties-run-history stack-3">
      <div
        v-if="logDetail"
        class="item-data-run-history m__b--0">
        <img
          :src="require('@/assets/automation/history.svg')"
          width="20">
        <div class="item-data-run-history__label">
          <div class="item-data-run-history__label-id">{{ logDetail.id }}</div>
          <div class="item-data-run-history__label-time">{{ convertDateTime(logDetail.time) }}</div>
        </div>
        <div class="item-data-run-history__div-runtime">
          <div class="item-data-run-history__label-runtime">Runtime</div>
          <div class="item-data-run-history__runtime">{{ logDetail.runtime }} ms</div>
        </div>
        <img
          :src="require(`@/assets/log/${logDetail.status}.png`)"
          height="23"
          width="23"
        >
        <div :class="`item-data-run-history__status ${logDetail.status}`">
          {{ logDetail.status === 'success' ? 'SUCCESS' : (logDetail.status === 'running' ? 'RUNNING' : 'ERROR') }}
        </div>
        <div
          class="close-properties-automation"
          @click="showBlockStack3Properties = false">
          <img
            :src="require('@/assets/icon/icon-close-properties.svg')"
            width="25">
        </div>
      </div>

      <div class="list-data-run-history">
        <div
          v-if="showLogDetail && logDetail"
          class="item-data-run-history-info-type">
          <div class="d-flex">
            <img
              :src="require(`@/assets/automation/${getIconBlockLog(logDetail, indexBlockLogSelected)}.svg`)"
              width="20"
              height="20"
              class="m__r--5">
            <div class="title-automation m__r--5">{{ getNameBlockLog(logDetail, indexBlockLogSelected) }}</div>
            <div class="id-block-automation">{{ logDetail.action_id ? `#${logDetail.action_id}` : '' }}</div>
          </div>
          <div
            v-if="dataDetail.trigger.type === 'form' && indexBlockLogSelected === 0"
            class="info-data-manager"
          >
            <img
              :src="require('@/assets/automation/data_manager.svg')"
              width="20"
              height="20"
            >
            <div class="m__l--5">
              <div class="label-form-data-name">{{ dataDetail.trigger.form.form_data_name }}</div>
              <div class="label-event">{{ dataDetail.trigger.form.event.replace('_', ' ') }}</div>
            </div>
          </div>
        </div>
        <label>Result</label>
        <div
          v-if="showLogDetail && loadLogDetailData"
          class="d-flex justify-content-center align-items-center"
          style="height: 400px; width: 100%">
          <div class="lds-ellipsis"><div/><div/><div/><div/></div>
        </div>
        <div
          v-if="showLogDetail && !loadLogDetailData && logDetail.warning"
          class="container-warning-log-detail">
          <div class="warning-log-detail">{{ logDetail.warning }}</div>
        </div>
        <div
          v-if="showLogDetail && !loadLogDetailData && logDetail.status === 'error'"
          class="container-error-log-detail">
          {{ logDetail.error }}
        </div>
        <div
          v-if="showLogDetail && !loadLogDetailData"
          class="container-data-log-detail">
          <pre class="debug-log-detail">{{ logDetail.data }}</pre>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, no-console, max-len, no-unused-vars, func-names, object-shorthand, semi, no-plusplus */
import jwtDecode from 'jwt-decode';
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';

import jApi from '@/services/jApi';
import jAutomationTrigger from '@/views/visual-programming/jVPBlockTrigger';
import jAutomationAction from '@/views/visual-programming/jVPBlockAction';
import jAutomationConditional from '@/views/visual-programming/jVPBlockConditional';
import jAutomationWhile from '@/views/visual-programming/jVPBlockWhile';
import jAutomationJavascript from '@/views/visual-programming/jVPBlockJavascript';
import DiagramView from '@/views/visual-programming/DiagramView';
import jVPJobMonitoring from '@/views/visual-programming/jVPJobMonitoring';
import jVPDedicatedJobMonitoring from '@/views/visual-programming/jVPDedicatedJobMonitoring';
import ModalListAction from '@/views/visual-programming/popup/ModalListAction';
import jPopoverFilterRunHistory from '@/views/visual-programming/popover/jPopoverFilterRunHistory';

import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import jTooltipCreateView from '@/components/tooltip/jTooltipCreateView';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'JAutomation',
  components: {
    jAutomationTrigger,
    jAutomationAction,
    jAutomationConditional,
    jAutomationWhile,
    jAutomationJavascript,
    jVPJobMonitoring,
    jVPDedicatedJobMonitoring,
    ModalListAction,
    DiagramView,
    jPopoverFilterRunHistory,

    jLoadingTable,
    jMonacoEditor,
    jTooltipCreateView,
  },
  directives: {
    ClickOutside,
  },
  validations: {
    name_automation: { required },
    description: {},
    active: {},
    is_sync: {},
  },
  data() {
    return {
      modeUpdateName: false,
      showBlockAutomation: false,
      configPopoverShow: false,
      showPopupNewVersion: false,
      isEditTitleActive: false,
      name_automation: '',
      description: '',
      disable_run_history: false,
      active: false,
      is_sync: false,
      data_automation: [],
      popoverAddAutomationShow: false,
      modeAutomation: 'diagram',
      dataDetail: null,
      dataDetailUpdated: null,
      jsonData: '',
      darkMode: false,
      showChevronUp: false,
      showLogDetail: false,
      historyDetail: null,
      logDetail: null,
      load_first: false,
      loadLogDetailData: true,
      data_table: [],
      countDataTable: 0,
      showDataTable: false,
      isBlockLog: false,
      dataListBlockLog: [],
      customPage: 1,
      historyActionBlockScript: null,
      showModalFullscreen: false,
      showCodeEditor: false,
      showBlockProperties: false,
      showBlockStack2Properties: false,
      showBlockStack3Properties: false,
      rotationDegrees: 0,
      isLoadingListLog: true,
      isLoadingListDetailLog: true,
      dataListRunHistory: [],
      pageRunHistory: 1,
      isUseInfinityScroll: false,
      indexBlockLogSelected: 0,
      showModalCodeEditor: false,
      showModalMonitoring: false,

      // Filter
      filterLog: null,
      filterDetailLog: null,
      popoverFilterLogShow: false,
      popoverFilterDetailLogShow: false,

      // Table Log History
      columns: ['id', 'status', 'runtime', 'time'],
      table_options: {
        headings: {
          id: 'RUNNING BLOCK ID',
          status: 'LOG',
          runtime: 'RUNTIME',
          time: 'DATE TIME',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              automation_id: data.automation_id,
            },
            count: data.count,
          };
        },
        requestFunction(data) {
          const api = jApi.generateApi();
          const getList = api.get('nocode/studio/automation/log/list', { params: data.pagination }).then(res => ({
            data: res,
            countData: data.count,
          }));
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data, countData }) {
          return {
            data: data.data.data ? data.data.data : [],
            count: countData,
          };
        },
      },

      // Table Detail Log History
      columns_block: ['id', 'action_id', 'type', 'status', 'runtime', 'time'],
      table_options_block: {
        headings: {
          id: 'ID',
          action_id: 'BLOCK ID',
          type: 'BLOCK TYPE',
          status: 'LOG',
          runtime: 'RUNTIME',
          time: 'DATE TIME',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: false,
        perPage: 100,
      },

      // Zoomable
      zoomOptions: {
        minZoom: 0.5,
        maxZoom: 1.5,
        beforeWheel: function (e) {
          const shouldIgnore = !e.ctrlKey;
          return shouldIgnore;
        },
        zoomDoubleClickSpeed: 1,
        smoothScroll: true,
      },

      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      intervalGetData: null,
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreAutomation', [
      'propertiesOpened',
      'propertiesTypeBlock',
      'propertiesDataBlock',
      'propertiesIndexBlock',
      'propertiesRowBlock',
      'propertiesDataParentBlock',
      'propertiesIDBlock',
      'dataDragBlockAction',
      'dataDropBlockAction',
      'popoverAddBlock',
    ]),

    isConditional() {
      const lastIndex = this.data_automation.length - 1;
      return lastIndex >= 0 ? this.data_automation[lastIndex].type === 'conditional' : false;
    },

    isWhile() {
      const lastIndex = this.data_automation.length - 1;
      return lastIndex >= 0 ? this.data_automation[lastIndex].type === 'while' : false;
    },

    infoTooltip() {
      return `
        <div style="font-size: 9px; font-family: Poppins-Medium; color: #5A5B5A;"> How to turn On/Off this visual programming ? </div>
        <div style="font-size: 9px; font-family: Poppins-Regular; color: #5A5B5A;">
          a. Click <i class="fa fa-ellipsis-v"></i> on right side <br>
          b. Select menu “<b style="font-family: Poppins-Bold;">Config</b>” <br>
          c. Set enable/disable toggle "<b style="font-family: Poppins-Bold;">Active</b>"
        <div>
      `;
    },

    visprogId() {
      return (this.dataDetail && this.dataDetail.trigger && (this.dataDetail.trigger.type === 'job' || this.dataDetail.trigger.type === 'dedicated_job')) ? this.dataDetail.id : null
    },

    // Trigger name
    triggerName() {
      if (this.dataDetail && this.dataDetail.trigger) {
        if (this.dataDetail.trigger.type === 'form') return this.dataDetail.trigger.form.form_data_name;
        if (this.dataDetail.trigger.type === 'job') return this.dataDetail.trigger.job.name;
        if (this.dataDetail.trigger.type === 'dedicated_job') return this.dataDetail.trigger.dedicated_job.name;
        if (this.dataDetail.trigger.type === 'event') return this.dataDetail.trigger.event.name;
        if (this.dataDetail.trigger.type === 'function') return this.dataDetail.trigger.function.name;
      }
      return ''
    },

    // Base url for API or Webhook
    baseURL() {
      if (this.dataDetail && this.dataDetail.trigger) {
        const type = this.dataDetail.trigger.type;

        if (type === 'api_v2') return `${process.env.URL_API_V2}${this.session.user.company_id}`;
        else if (type === 'webhook_v2') return `${process.env.URL_WEBHOOK_V2}${this.session.user.company_id}`;
        return `${process.env.GATE_URL}nocode/${type}`;
      }
      return '';
    },

    // Calculate time ago from timestamp
    timeAgo() {
      if (this.dataDetail.updated_at) {
        const date = new Date(this.dataDetail.updated_at);
        const seconds = Math.floor((new Date() - date) / 1000);

        let interval = Math.floor(seconds / 31536000);
        if (interval >= 1) {
          return `Saved ${interval} year ago`;
        }
        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
          return `Saved ${interval} month ago`;
        }
        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
          return `Saved ${interval} day ago`;
        }
        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
          return `Saved ${interval} hour ago`;
        }
        interval = Math.floor(seconds / 60);
        if (interval >= 1) {
          return `Saved ${interval} min ago`;
        }
        return 'Saved just now';
      }

      return '-'
    },

    imageStyleRotate() {
      return {
        transform: `rotate(${this.rotationDegrees}deg)`,
      };
    },
  },
  watch: {
    dataDetail(data) {
      this.name_automation = data.name;
      this.description = data.description;
      this.disable_run_history = data.disable_run_history || false;
      this.active = data.is_active || false;
      this.is_sync = data.is_sync || false;

      if (data.actions) {
        data.actions.forEach((e, index) => {
          const dataActions = this.setDataAction(e, index);
          this.data_automation.push(dataActions);
        });
      }
      this.showBlockAutomation = true;
    },

    showBlockAutomation(val) {
      setTimeout(() => {
        this.setPausePanZoom(this.$refs.zoomWrapper.$panZoomInstance.pause);
        this.setResumePanZoom(this.$refs.zoomWrapper.$panZoomInstance.resume);
      }, 600)
    },

    dataDropBlockAction() {
      const data = this._.cloneDeep(this.dataDetail);
      let dataActions = data.actions;

      // hapus block didata asal
      this.dataDragBlockAction.data_parent.forEach((e) => {
        const position = e.type === 'conditional' ?
          (e.position === 'array_right' ? 'action_false' : 'action_true') :
          (e.position === 'array_right' ? 'action_done' : 'action_while');
        dataActions = dataActions[e.index][e.type][position];
      });
      const dataBlock = this._.cloneDeep(dataActions[this.dataDragBlockAction.index]);
      dataActions.splice(this.dataDragBlockAction.index, 1);

      // tambahkan block didata tujuan
      dataActions = data.actions;
      this.dataDropBlockAction.data_parent.forEach((e) => {
        const position = e.type === 'conditional' ?
          (e.position === 'array_right' ? 'action_false' : 'action_true') :
          (e.position === 'array_right' ? 'action_done' : 'action_while');
        dataActions = dataActions[e.index][e.type][position];
      });
      dataActions.splice(this.dataDropBlockAction.index, 0, dataBlock);

      this.applyAutomation({ payload: data, useLoading: true }).then(() => { this.setDetail(); });
    },
  },
  created() {
    if (this.$route.params.automationId) this.setDetail();
    setTimeout(() => {
      this.setSidebarMinimized(false);
    }, 300);
    this.actionGetUserCompanySettingV2(false);
  },
  mounted() {
    // Refetch every 1 minutes
    if (this.$route.params.automationId) {
      this.intervalGetData = setInterval(this.getDataDetail, 60000)
    }
  },

  beforeDestroy() {
    if (this.intervalGetData) clearInterval(this.intervalGetData);
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreAutomation', ['applyAutomation', 'getDetailAutomation', 'deleteAutomation', 'getListRunHistory', 'getListActionBlock', 'getDetailActionBlock']),
    ...mapActions('jStoreSetting', ['actionGetUserCompanySettingV2']),
    ...mapActions('jStoreForm', ['actionServiceSwitcher']),
    ...mapMutations('jStoreAutomation', ['setPropertiesOpened', 'setPausePanZoom', 'setResumePanZoom', 'changePropertiesOpened', 'setPopoverAddBlock']),
    ...mapMutations('jStoreSetting', ['setSidebarMinimized']),

    setDetail() {
      const dataFilter = {
        id: [this.$route.params.automationId],
      };
      const param = {
        limit: 10,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((data) => {
        this.data_automation = [];
        this.dataDetail = data.data.data.find(e => e.id === this.$route.params.automationId);
        this.jsonData = JSON.stringify(this.dataDetail, null, 4);

        if (this.showModalFullscreen) this.hidePropertiesFull('setDetail')
        else this.hideProperties('setDetail');

        setTimeout(() => {
          this.closeConfigAutomation();
        }, 100)
      });
    },

    setDataAction(e, index) {
      const dataActions = {
        id: Number(`${Math.floor(Math.random() * 100)}${Math.floor(Math.random() * 100)}`),
        type: e.type === 'conditional' || e.type === 'while' || e.type === 'javascript' ? e.type : 'action',
        dataEdit: e,
        array_left: [],
        array_right: [],
      };

      if (e.type === 'conditional') {
        e.conditional.action_true.forEach((t, indexTrue) => {
          const dataActionsConTrue = this.setDataAction(t, indexTrue);
          dataActions.array_left.push(dataActionsConTrue);
        });
        e.conditional.action_false.forEach((t, indexFalse) => {
          const dataActionsConFalse = this.setDataAction(t, indexFalse);
          dataActions.array_right.push(dataActionsConFalse);
        });
      }

      if (e.type === 'while') {
        e.while.action_while.forEach((t, indexWhile) => {
          const dataActionsConTrue = this.setDataAction(t, indexWhile);
          dataActions.array_left.push(dataActionsConTrue);
        });
        e.while.action_done.forEach((t, indexDone) => {
          const dataActionsConFalse = this.setDataAction(t, indexDone);
          dataActions.array_right.push(dataActionsConFalse);
        });
      }

      return dataActions;
    },

    getDataDetail() {
      const dataFilter = {
        id: [this.$route.params.automationId],
      };
      const param = {
        limit: 10,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((data) => {
        if (!data.data.error) {
          const response = data.data.data[0]

          if (response.updated_at && response.updated_at !== this.dataDetail.updated_at) {
            this.showPopupNewVersion = true;
            this.dataDetailUpdated = response;
          }
        }
      });
    },

    updateNewVersion() {
      this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Updating version');

      this.data_automation = [];
      this.dataDetail = this.dataDetailUpdated;
      this.jsonData = JSON.stringify(this.dataDetail, null, 4);

      if (this.showModalFullscreen) this.hidePropertiesFull('setDetail')
      else this.hideProperties('setDetail');

      this.showPopupNewVersion = false;
      this.dataDetailUpdated = null;

      setTimeout(() => {
        this.closeConfigAutomation();
      }, 100)

      setTimeout(() => {
        this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
        this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Visual programming has been updated');
      }, 1000)
    },

    editTitleAutomation() {
      this.isEditTitleActive = true;

      setTimeout(() => {
        this.$refs.titleInput.focus();
      }, 100);
    },

    updateTitleAutomation() {
      if (this.isEditTitleActive) {
        if (this.name_automation && this.name_automation === this.dataDetail.name) {
          this.isEditTitleActive = false;
        } else if (this.name_automation) {
          this.isEditTitleActive = false;
          const data = this._.cloneDeep(this.dataDetail);
          data.name = this.name_automation;
          this.applyAutomation({ payload: data, useLoading: false }).then(() => { this.setDetail(); });
        } else {
          this.toggleProblem('Title cannot be empty');
        }
      }
    },
    hideAllPopover() {
      this.popoverAddAutomationShow = false;
      this.configPopoverShow = false;
    },

    configAutomation() {
      this.$refs.configModal.show();
      this.configPopoverShow = false;
      this.modeUpdateName = true;
    },

    closeConfigAutomation() {
      this.$refs.configModal.hide();
      this.name_automation = this.dataDetail.name;
      this.description = this.dataDetail.description;
      this.active = this.dataDetail.is_active || false;
      this.is_sync = this.dataDetail.is_sync || false;
      this.disable_run_history = this.dataDetail.disable_run_history || false;
      this.modeUpdateName = false;
    },

    loading(val) {
      const a = val;
      a.pagination.page = this.customPage;
      a.pagination.automation_id = this.$route.params.automationId;
      a.count = this.countDataTable;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    selectTab(data) {
      this.modeAutomation = data;
      if (data === 'log') {
        this.customPage = 1;
        this.showDataTable = false;
        setTimeout(() => { this.showDataTable = true; }, 100);
      }
      if (data === 'code') {
        setTimeout(() => {
          this.showCodeEditor = true;
        }, 100);
      }
      // this.setPropertiesOpened({ open: false });
    },

    previousPage() {
      if (this.customPage > 1) {
        this.customPage = this.customPage - 1;
        this.$refs.automationLogComponent.refresh();
      }
    },

    forwardPage() {
      if (this.data_table.length === 10) {
        this.customPage = this.customPage + 1;
        this.$refs.automationLogComponent.refresh();
      }
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
        const secound = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}:${secound}`;
      }
      return null;
    },

    openBlockProperties(type, stackLevel, data, index) {
      if (type === 'code-editor') {
        this.toggleModalCodeEditor(true);
      }
      if (type === 'monitoring') {
        this.toggleModalMonitoring(true);
      }
      if (type === 'run-history') {
        if (stackLevel === 3) {
          this.indexBlockLogSelected = index;
          this.showBlockStack3Properties = true;
          this.openDetailBlockLog(data);
        } else if (stackLevel === 2) {
          this.historyDetail = data;
          this.showBlockStack2Properties = true;
          this.getDataBlockLog();
        } else {
          this.showBlockProperties = true;
          this.getDataRunHistory();

          const el = document.getElementById('data-list-history');
          el.onscroll = async () => {
            if (this.isUseInfinityScroll) {
              if (Math.floor(el.scrollHeight - el.scrollTop) === el.clientHeight) {
                this.pageRunHistory += 1;
                this.isUseInfinityScroll = false;

                const param = {
                  limit: 50,
                  page: this.pageRunHistory,
                  automation_id: this.$route.params.automationId,
                };
                this.getListRunHistory(param).then((res) => {
                  if (res.data.data.length > 0) {
                    this.dataListRunHistory.push(...res.data.data);
                    setTimeout(() => {
                      this.isUseInfinityScroll = true;
                    }, 300);
                  } else {
                    this.isUseInfinityScroll = false;
                  }
                });
              }
            }
          };
        }
      }
    },

    getDataRunHistory(rotationIcon = true) {
      this.pageRunHistory = 1;
      this.dataListRunHistory = [];
      this.isLoadingListLog = true;
      this.isUseInfinityScroll = false;
      if (rotationIcon) this.rotationDegrees += 360;

      const param = {
        limit: 50,
        page: 1,
        automation_id: this.$route.params.automationId,
      };
      if (this.filterLog) param.filter = this.filterLog;
      this.getListRunHistory(param).then((res) => {
        this.dataListRunHistory = res.data.data;
        this.isUseInfinityScroll = true;
        this.isLoadingListLog = false;
      });
    },

    getDataBlockLog(rotationIcon = true) {
      this.dataListBlockLog = [];
      this.isLoadingListDetailLog = true;
      if (rotationIcon) this.rotationDegrees += 360;

      const param = {
        limit: 1000000,
        page: 1,
        automation_id: this.$route.params.automationId,
        running_id: this.historyDetail.id,
      };
      if (this.filterDetailLog) param.filter = this.filterDetailLog;
      this.getListActionBlock(param).then((res) => {
        this.dataListBlockLog = res.data.data.actions;
        this.isLoadingListDetailLog = false;
      });
    },

    openDetailBlockLog(data) {
      this.showLogDetail = true;
      this.loadLogDetailData = true;
      const param = {
        limit: 10,
        page: 1,
        automation_id: this.$route.params.automationId,
        running_id: data.running_id,
        action_id: data.action_id,
        id: data.id,
      };
      this.getDetailActionBlock(param).then((res) => {
        this.logDetail = {
          action_id: res.data.data.action_id,
          type: res.data.data.type,
          runtime: res.data.data.runtime,
          data: JSON.stringify(res.data.data.data, null, 4),
          error: res.data.data.error,
          status: res.data.data.status,
          warning: res.data.data.warning,
          time: res.data.data.time,
          id: res.data.data.id,
        };
        this.loadLogDetailData = false;
      });
    },

    hideProperties(action) {
      if (action !== 'setDetail') {
        if (this.propertiesRowBlock > 1) {
          let dataActions = this.data_automation;
          this.propertiesDataParentBlock.forEach((e) => {
            dataActions = dataActions[e.index][e.position];
          });

          if (!this.propertiesDataBlock || !this.propertiesDataBlock.id) {
            dataActions.splice(this.propertiesIndexBlock, 1);
          }
        } else if (this.data_automation.length > 0) {
          // eslint-disable-next-line
          if (!this.propertiesDataBlock || !this.propertiesDataBlock.id) {
            this.data_automation.splice(this.propertiesIndexBlock, 1);
          }
        }
      }
      this.historyActionBlockScript = null;
      this.setPropertiesOpened({ open: false });
    },

    addBlock(type) {
      const data = {
        id: Number(`${Math.floor(Math.random() * 100)}${Math.floor(Math.random() * 100)}`),
        type,
        dataEdit: null,
        array_left: [],
        array_right: [],
      };
      this.data_automation.push(data);
      this.showProperties(data.id, type);
      this.popoverAddAutomationShow = false;
    },

    showProperties(id, type) {
      if (this.propertiesOpened) {
        this.setPropertiesOpened({ open: false });

        setTimeout(() => {
          this.setPropertiesOpened({
            open: true,
            type,
            index: this.data_automation.length - 1,
            row: 1,
            dataParent: [],
            idBlock: id,
          });
        }, 100);
      } else {
        this.setPropertiesOpened({
          open: true,
          type,
          index: this.data_automation.length - 1,
          row: 1,
          dataParent: [],
          idBlock: id,
        });
      }
    },

    fullscreenBlock() {
      this.$refs.automationJavascriptPro.sendDataToggleFullScreen().then((data) => {
        this.historyActionBlockScript = data;
        this.changePropertiesOpened(false);

        setTimeout(() => {
          this.$refs.modalFullScript.show();
          this.showModalFullscreen = true;
        }, 200)
      }).catch(() => {
        setTimeout(() => {
          this.$refs.modalFullScript.show();
          this.showModalFullscreen = true;
        }, 200)
      })
    },

    minimizeBlock() {
      this.$refs.automationJavascriptFullPro.sendDataToggleFullScreen().then((data) => {
        this.historyActionBlockScript = data;
        this.$refs.modalFullScript.hide();
        this.showModalFullscreen = false;

        setTimeout(() => {
          this.setPropertiesOpened({
            open: true,
            type: 'javascript',
            data: this.historyActionBlockScript,
            index: this.propertiesIndexBlock,
            row: this.propertiesRowBlock,
            dataParent: this.propertiesDataParentBlock,
            idBlock: this.propertiesIDBlock,
          });
        }, 200)
      }).catch(() => {
        this.$refs.modalFullScript.hide();
        this.showModalFullscreen = false;

        setTimeout(() => {
          this.setPropertiesOpened({
            open: true,
            type: 'javascript',
            data: this.historyActionBlockScript,
            index: this.propertiesIndexBlock,
            row: this.propertiesRowBlock,
            dataParent: this.propertiesDataParentBlock,
            idBlock: this.propertiesIDBlock,
          });
        }, 200)
      })
    },

    hidePropertiesFull(action) {
      if (action !== 'setDetail') {
        if (this.propertiesRowBlock > 1) {
          let dataActions = this.data_automation;
          this.propertiesDataParentBlock.forEach((e) => {
            dataActions = dataActions[e.index][e.position];
          });

          if (!this.propertiesDataBlock || !this.propertiesDataBlock.id) {
            dataActions.splice(this.propertiesIndexBlock, 1);
          }
        } else if (this.data_automation.length > 0) {
          // eslint-disable-next-line
          if (!this.propertiesDataBlock || !this.propertiesDataBlock.id) {
            this.data_automation.splice(this.propertiesIndexBlock, 1);
          }
        }
      }
      this.showModalFullscreen = false;
      this.historyActionBlockScript = null;
      this.$refs.modalFullScript.hide();
      this.setPropertiesOpened({ open: false });
    },

    validateData() {
      this.$v.name_automation.$touch();
      return this.$v.name_automation.$error;
    },

    updateBlockAutomation() {
      const data = {
        id: this.$route.params.automationId,
        name: this.name_automation,
        description: this.description,
        disable_run_history: this.disable_run_history,
        is_active: this.active,
        is_sync: this.is_sync,
        trigger: this.dataDetail.trigger,
        actions: this.dataDetail.actions ? this._.cloneDeep(this.dataDetail.actions) : [],
      };

      if (this.propertiesTypeBlock === 'trigger') {
        if (!this.validateData() && !this.$refs.automationTriggerPro.validateData()) {
          this.$refs.automationTriggerPro.getData().then((params) => {
            data.trigger = params.data;
            data.name = params.dataVP.name;
            data.description = params.dataVP.description;
            data.disable_run_history = params.dataVP.disable_run_history;
            data.is_active = params.dataVP.is_active;
            this.applyAutomation({ payload: data, useLoading: true }).then(() => {
              this.setDetail();

              if (params.dataVP.is_update_service) {
                this.actionServiceSwitcher({
                  action: 'setAutomationSwitcher',
                  param: {
                    id: this.$route.params.automationId,
                    nocode_service_target: params.dataVP.nocode_service_target,
                  },
                });
              }
            });
          });
        } else {
          this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Invalid block automation');
        }
      } else {
        let ref;
        if (this.propertiesTypeBlock === 'action') {
          ref = this.$refs.automationActionPro;
        } else if (this.propertiesTypeBlock === 'javascript') {
          ref = this.showModalFullscreen ?
            this.$refs.automationJavascriptFullPro :
            this.$refs.automationJavascriptPro;
        } else if (this.propertiesTypeBlock === 'conditional') {
          ref = this.$refs.automationConditionalPro;
        } else if (this.propertiesTypeBlock === 'while') {
          ref = this.$refs.automationWhilePro;
        }

        if (!this.validateData() && typeof ref !== 'undefined' && !ref.validateData()) {
          ref.getData().then((params) => {
            if (this.propertiesRowBlock > 1) {
              let dataActions = data.actions;
              this.propertiesDataParentBlock.forEach((e) => {
                const position = e.type === 'conditional' ?
                  (e.position === 'array_right' ? 'action_false' : 'action_true') :
                  (e.position === 'array_right' ? 'action_done' : 'action_while');
                dataActions = dataActions[e.index][e.type][position];
              });

              if (this.propertiesDataBlock) {
                const index = dataActions.findIndex(block => block.id === params.id)

                if (this.propertiesTypeBlock === 'conditional') {
                  dataActions[index].conditional.query = params.conditional.query;
                  dataActions[index].is_disable = params.is_disable;
                } else if (this.propertiesTypeBlock === 'while') {
                  dataActions[index].while.variable_source = params.while.variable_source;
                  dataActions[index].container_variable = params.container_variable;
                  dataActions[index].is_disable = params.is_disable;
                } else {
                  dataActions[index] = params;
                }
              } else {
                dataActions.splice(this.propertiesIndexBlock, 0, params);
              }
            } else {
              // eslint-disable-next-line
              if (this.propertiesDataBlock) {
                const index = data.actions.findIndex(block => block.id === params.id)
                if (this.propertiesTypeBlock === 'conditional') {
                  data.actions[index].conditional.query = params.conditional.query;
                  data.actions[index].is_disable = params.is_disable;
                } else if (this.propertiesTypeBlock === 'while') {
                  data.actions[index].while.variable_source = params.while.variable_source;
                  data.actions[index].container_variable = params.container_variable;
                  data.actions[index].is_disable = params.is_disable;
                } else {
                  data.actions[index] = params;
                }
              } else {
                data.actions.splice(this.propertiesIndexBlock, 0, params);
              }
            }
            this.applyAutomation({ payload: data, useLoading: true }).then(() => { this.setDetail(); });
          });
        } else {
          this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Invalid block automation');
        }
      }
    },

    deleteBlockAutomation() {
      const text = 'Are you sure to delete this block?';
      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const data = {
            id: this.$route.params.automationId,
            name: this.name_automation,
            description: this.description,
            disable_run_history: this.disable_run_history,
            is_active: this.active,
            is_sync: this.is_sync,
            trigger: this.dataDetail.trigger,
            actions: this.dataDetail.actions,
          };
          if (this.propertiesRowBlock > 1) {
            let dataActions = data.actions;
            this.propertiesDataParentBlock.forEach((e) => {
              const position = e.type === 'conditional' ?
                (e.position === 'array_right' ? 'action_false' : 'action_true') :
                (e.position === 'array_right' ? 'action_done' : 'action_while');
              dataActions = dataActions[e.index][e.type][position];
            });
            const index = dataActions.findIndex(block => block.id === this.propertiesDataBlock.id)

            dataActions.splice(index, 1);
          } else {
            const index = data.actions.findIndex(block => block.id === this.propertiesDataBlock.id)
            data.actions.splice(index, 1);
          }
          this.applyAutomation({ payload: data, useLoading: true }).then(() => { this.setDetail(); });
        }
      });
    },

    updateConfigAutomation() {
      const text = 'Are you sure to save this config ?';
      this.$swal({
        title: 'Save Config',
        text,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.value) {
          const data = this.dataDetail;
          data.name = this.name_automation;
          data.description = this.description;
          data.is_active = this.active;
          data.is_sync = this.is_sync;
          data.disable_run_history = this.disable_run_history;

          this.applyAutomation({ payload: data, useLoading: true }).then(() => { this.setDetail(); });
        }
      });
    },

    applyOnlyAutomation() {
      try {
        const data = JSON.parse(this.$refs.scriptEditor.getData());
        this.applyAutomation({ payload: data, useLoading: true }).then(() => {
          this.setDetail();
          this.toggleModalCodeEditor(false);
        });
      } catch (err) {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Invalid JSON code');
      }
    },

    removeAutomation() {
      const text = 'Are you sure to delete this data?';

      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const param = {
            id: this.$route.params.automationId,
          };
          this.deleteAutomation(param);
        }
      });
    },

    // Copy to clipboard
    copyToClipboard() {
      const type = this.dataDetail.trigger.type
      let value = ''

      if (!type.includes('api') && !type.includes('webhook')) {
        value = this.triggerName
      } else {
        value = `${this.baseURL}/${this.dataDetail.trigger[this.dataDetail.trigger.type].url}`
      }

      const el = document.createElement('textarea');
      el.value = value;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Copied to clipboard');
    },

    handleZoom(type) {
      const zoomValue = type === 'zoomin' ? 1.4 : 0.8;
      this.$refs.zoomWrapper.$panZoomInstance.smoothZoom(0, 0, zoomValue);
    },

    getIconBlockLog(data, index) {
      const triggerTypes = ['form', 'api', 'api_v2', 'webhook', 'webhook_v2', 'function', 'job', 'dedicated_job', 'event'];
      const dataManagerTypes = ['create_record', 'create_records', 'find_record', 'find_records', 'update_record', 'delete_record'];
      const fileTransferTypes = ['ftp_read_single_file', 'ftp_get_list_directory', 'ftp_download_single_file', 'ftp_upload', 'ftp_move_single_file', 'ftp_delete_single_file'];
      const iconMap = {
        javascript: 'script-color',
        conditional: 'conditional-color',
        while: 'while-color',
        joana: 'joana-color',
        data_connectivity: 'data-connectivity-color',
        external_api: 'api-color',
        function: 'function-color',
        job: 'job-color',
        dedicated_job: 'dedicated-job-color',
        send_email: 'send-notif-color',
        send_notification: 'send-notif-color',
        generate_file_csv: 'sheet-color',
        generate_file_text: 'sheet-color',
      };

      if (index === 0 && triggerTypes.includes(data.type)) return 'trigger';
      if (iconMap[data.type]) return iconMap[data.type];
      if (dataManagerTypes.includes(data.type)) return 'data-manager-color';
      if (fileTransferTypes.includes(data.type)) return 'file-transfer-color';

      return 'action';
    },

    getNameBlockLog(data, index) {
      const triggerTypes = ['form', 'api', 'api_v2', 'webhook', 'webhook_v2', 'function', 'job', 'dedicated_job', 'event'];
      const dataManagerTypes = ['create_record', 'create_records', 'find_record', 'find_records', 'update_record', 'delete_record'];
      const fileTransferTypes = ['ftp_read_single_file', 'ftp_get_list_directory', 'ftp_download_single_file', 'ftp_upload', 'ftp_move_single_file', 'ftp_delete_single_file'];
      const nameMap = {
        javascript: 'SCRIPT',
        conditional: 'CONDITIONAL',
        while: 'WHILE',
        joana: 'BIG DATA ENGINE',
        data_connectivity: 'DATA CONNECTIVITY',
        external_api: 'API',
        function: 'FUNCTION',
        job: 'JOB',
        dedicated_job: 'DEDICATED JOB',
        send_email: 'SEND NOTIFICATION',
        send_notification: 'SEND NOTIFICATION',
        generate_file_csv: 'GENERATE FILE',
        generate_file_text: 'GENERATE FILE',
      };

      if (index === 0 && triggerTypes.includes(data.type)) return 'TRIGGER';
      if (nameMap[data.type]) return nameMap[data.type];
      if (dataManagerTypes.includes(data.type) || fileTransferTypes.includes(data.type)) {
        return data.type.replace('_', ' ').toUpperCase();
      }

      return 'ACTION';
    },

    toggleModalCodeEditor(status) {
      if (status) {
        this.showModalCodeEditor = true;
        setTimeout(() => {
          const element = document.getElementById('modal-code-editor');
          if (element) element.classList.add('show');
        }, 200);
        setTimeout(() => { this.showCodeEditor = true; }, 500);
      } else {
        const element = document.getElementById('modal-code-editor');
        if (element) element.classList.remove('show');
        this.showCodeEditor = false;

        setTimeout(() => {
          this.showModalCodeEditor = false;
        }, 200);
      }
    },

    toggleModalMonitoring(status) {
      if (status) {
        this.showModalMonitoring = true;
        setTimeout(() => {
          const element = document.getElementById('modal-monitoring');
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById('modal-monitoring');
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.showModalMonitoring = false;
        }, 200);
      }
    },

    selectActionBlock(data) {
      this.addBlock(data.type);
      this.hideAllPopoverAdd();
    },

    handleFilterLog(filter) {
      this.closePopoverFilterLog();
      this.pageRunHistory = 1;
      this.dataListRunHistory = [];
      this.isLoadingListLog = true;
      this.isUseInfinityScroll = false;
      if (Object.keys(filter).length > 0) this.filterLog = filter;

      const param = {
        limit: 50,
        page: 1,
        automation_id: this.$route.params.automationId,
        filter,
      };
      this.getListRunHistory(param).then((res) => {
        this.dataListRunHistory = res.data.data;
        this.isUseInfinityScroll = true;
        this.isLoadingListLog = false;
      });
    },

    handleFilterDetailLog(filter) {
      this.closePopoverFilterDetailLog();
      this.dataListBlockLog = [];
      this.isLoadingListDetailLog = true;
      if (Object.keys(filter).length > 0) this.filterDetailLog = filter;

      const param = {
        limit: 1000000,
        page: 1,
        automation_id: this.$route.params.automationId,
        running_id: this.historyDetail.id,
        filter,
      };
      this.getListActionBlock(param).then((res) => {
        this.dataListBlockLog = res.data.data.actions;
        this.isLoadingListDetailLog = false;
      });
    },

    resetFilterLog() {
      this.closePopoverFilterLog();
      this.filterLog = null;
      this.getDataRunHistory(false);
    },

    resetFilterDetailLog() {
      this.closePopoverFilterDetailLog();
      this.filterDetailLog = null;
      this.getDataBlockLog(false);
    },

    openPopoverAdd(dataRef) {
      this.hideAllPopoverAdd();
      setTimeout(() => {
        this.setPopoverAddBlock(dataRef);
        setTimeout(() => {
          this.$refs[dataRef].$emit('open');
        }, 200)
      }, 150);
    },

    hideAllPopoverAdd() {
      if (this.popoverAddBlock && this.$refs[this.popoverAddBlock]) {
        this.$refs[this.popoverAddBlock].$emit('close');
      }
      this.setPopoverAddBlock(null);
    },

    openPopoverFilterLog() {
      this.popoverFilterLogShow = true;
    },

    closePopoverFilterLog() {
      this.popoverFilterLogShow = false;
    },

    openPopoverFilterDetailLog() {
      this.popoverFilterDetailLogShow = true;
    },

    closePopoverFilterDetailLog() {
      this.popoverFilterDetailLogShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/jVPMain.vue